<script setup>

const props = defineProps({
    year: {
        type: Number,
        default: () => new Date().getFullYear()
    },
    month: {
        type: Number,
        default: () => new Date().getMonth() + 1
    },
})

const emit = defineEmits(['setYear', 'setMonth'])

const options = [
    'all',
    'annual','personal','sick','compensatory',
    'official','compensatory','marriage','prenatal_checkup','maternity','paternity','menstruation',
    'parental','funeral','tocolysis',
]

const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];

function setYear(operator) {
    emit('setYear', operator)
}

function setMonth(e) {
    emit('setMonth', e.target.value)
}
function setLeaveType(e) {
    emit('setLeaveType', e.target.value)
}

</script>

<template>
    <div class="w-full grid grid-cols-1 gap-4">
        <div class="grid grid-cols-3 items-center">
            <div class="text-center">
                <button @click="setYear('-')" class="rounded  px-2 py-1 bg-indigo-400 text-white">◀︎</button>
            </div>
            <div class="text-center text-lg font-bold">
                {{ year }}
            </div>
            <div class="text-center">
                <button @click="setYear('+')" class="rounded  px-2 py-1 bg-indigo-400 text-white">▶︎︎</button>
            </div>
        </div>
        <div class="grid grid-cols-2 gap-2">
            <select :value="month" class="w-full rounded border border-gray-400" @change="setMonth">
                <option v-for="(month, index) in MONTH_NAMES" :key="month" :value="index+1">{{month}}</option>
            </select>
            <select class="w-full rounded border border-gray-400" @change="setLeaveType">
                <option v-for="option in options" :key="option" :value="option">{{ option}}</option>
            </select>
        </div>
    </div>
</template>
